window.assetsFolder = "";
